export const filterQuery = <T>(
  [key, val]: [keyof T, T[keyof T]],
  additionalKeys?: string[]
) => {
  const excludedParams = ['modal', 'island'].concat(additionalKeys || []);
  if (excludedParams.includes(key as string)) {
    return false;
  }
  if (
    val === null ||
    val === false ||
    val === '' ||
    (Array.isArray(val) && val.length === 0)
  ) {
    return false;
  }
  return true;
};
